module.exports = __webpack_public_path__ + "static/C2021_ASCE_abs-34834a9c97f94d5e8681863d71ebbae4.jpg";